<template>
  <div v-show="isShowingModalDuplicateDesign" class="process-duplicate-design p-3 pt-4 mt-4 z-10"
    :style="`width: ${width}`">
    <br />

    <b-button variant="light" @click="manegeView(false)" class="d-flex align-items-center">
      <i class="fa fa-chevron-left p-0 mr-2"></i>
      CERRAR VISTA
    </b-button>

    <b-card v-if="duplicateDesign" no-body class="mt-3 border-0">
      <!-- Si es un diseño de empresa - mostrar datos de la empresa (visibles no editables) -->
      <div class="mx-2 text-center">
        <!-- Empresa -->
        <b-row class="mt-2">

          <!-- Título y medidas -->
          <b-col cols="12">
            <div class="bg-header p-3 d-flex justify-content-between flex-wrap">
              <div class="d-flex text-left">
                <i class="fa fa-clone fa-lg mt-3"></i>
                <div class="ml-2 font-weight-bold">
                  <strong>{{ duplicateDesign.design.title }}</strong>
                  <small class="text-muted d-block mt-1">
                    Duplicar diseño <i class="fa" :class="isDesignByCompany ? 'fa-building' : 'fa-globe'"></i> {{
                    getTypeDesign }}
                  </small>
                  <p v-if="isDesignByCompany" class="m-0 font-weight-bold">
                    {{ duplicateDesign.company.nombre }}
                  </p>
                </div>
              </div>

              <div>
                <strong>Medidas</strong>
                <h4><b-badge class="d-block" variant="info" size="lg">{{ duplicateDesign.design.width }} cm ·
                    {{ duplicateDesign.design.height }} cm</b-badge></h4>
              </div>
            </div>
          </b-col>

          <!-- Seleccionar empresa -->
          <b-col cols="12" class="mt-2">

            <!-- Selector de empresa -->
            <b-form-group class="text-left">
              <label for="width" v-b-tooltip.hover
                title="Selecciona la empresa destino a la que quieres duplicar el diseño">
                <i class="fa fa-building mr-2"></i>
                Seleccionar empresa destino
              </label>
              <el-select v-model="duplicateDesign.to_company_id" @change="onChangeCompany" filterable remote clearable
                no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                :remote-method="onHandleSearchCompany" :loading="globalLoading">
                <el-option v-for="company in companiesFilterTemporary" :key="company.id" :label="company.nombre" :value="company.id">
                </el-option>
              </el-select>
            </b-form-group>
          </b-col>

          <!-- Nombre del nuevo diseño -->
          <b-col cols="12" class="mt-2">
            <b-form-group class="text-left">
              <label for="width" v-b-tooltip.hover title="Nombre del nuevo diseño">
                <i class="fa fa-file-text-o mr-2"></i>
                Nombre del nuevo diseño <span class="text-danger">(*)</span>
              </label>
              <b-form-input v-model="duplicateDesign.new_design_title" type="text" placeholder="Nombre del nuevo diseño"></b-form-input>
            </b-form-group>
          </b-col>

        </b-row>
      </div>

      <!-- Botón de duplicación -->
      <br />
      <div class="ml-3 d-flex justify-content-center">
        <b-button variant="info" @click="() => onDuplicateDesign()">
          <i class="fa fa-clone"></i>
          Duplicar diseño
        </b-button>
      </div>

      <br />
    </b-card>
  </div>
</template>

<script>
// Importaciones generales
import { mapMutations, mapState, mapActions } from "vuex";

// Componentes

export default {
  name: "labelDesignerPreviewDesign",

  props: {
    width: {
      type: String,
      default: "700pt",
      required: false,
    },
  },

  data() {
    return {
      companiesFilterTemporary: [],
    };
  },

  watch: {
    duplicateDesign(newVal) {
      if (newVal.is_showing) {
        this.companiesFilterTemporary = [];
      }
    },
  },

  computed: {
    ...mapState("labelDesigner", ["duplicateDesign", 'filterHistory']),

    ...mapState("dashboard", {
      globalLoading: "cargando_datos_select",
    }),

    isShowingModalDuplicateDesign() {
      return this.duplicateDesign.is_showing;
    },

    isDesignByCompany() {
      return this.duplicateDesign.type === "BY_COMPANY";
    },

    getTypeDesign() {
      return this.isDesignByCompany ? "de empresa" : "general";
    },
  },

  methods: {
    ...mapMutations("labelDesigner", ["setDuplicateDesign"]),

    ...mapActions("empresa",['getCompaniesByFilterName']),

    ...mapActions("labelDesigner", {
      duplicate: "duplicateDesign",
      getLabelDesigns: 'getLabelDesigns'
    }),

    manegeView(isShow) {
      this.setDuplicateDesign({...this.duplicateDesign,
        is_showing: isShow,
      });
    },

    async onHandleSearchCompany(nameCompany) {
      if (!(nameCompany.length >= 1)) return;

      await this.getCompaniesByFilterName({ 
        param: { nombre: nameCompany }, 
        callback: this.callbackGetCompaniesByFilterName
      });
    },

    callbackGetCompaniesByFilterName(status, response) {
      if (!status) return;

      this.companiesFilterTemporary = response.data;
    },

    onChangeCompany(companyId) {
      if (companyId && this.isDesignByCompany && companyId === this.duplicateDesign.company.id) {
        this.duplicateDesign.to_company_id = null;

        this.$alertError("No puedes duplicar el diseño a la misma empresa",2000,false,"¡Error!","info");
        return;
      }

      this.duplicateDesign.to_company_id = companyId;
    },

    async onDuplicateDesign() {

      if (!this.duplicateDesign.new_design_title) {
        this.$alertError("Debes ingresar un nombre para el nuevo diseño",2000,false,"Validación de datos","info");
        return;
      }

      const payload = {
        type: this.duplicateDesign.type,
        company_owner_design_id: this.isDesignByCompany ? this.duplicateDesign.company.id : null,
        company_to_duplicate_id: this.duplicateDesign.to_company_id,
        design_id: this.duplicateDesign.design.id,
        new_design_title: this.duplicateDesign.new_design_title,
        callback: this.callbackDuplicateDesign
      };
      
      await this.duplicate(payload);
    },

    async callbackDuplicateDesign(status, { response, payload }) {
      if (!status) return;

      if (payload.company_to_duplicate_id && payload.company_to_duplicate_id === this.filterHistory.company_id) {
        await this.getLabelDesigns({ type: 'BY_COMPANY', company_id: payload.company_to_duplicate_id });
      } else if (!payload.company_to_duplicate_id) {
        await this.getLabelDesigns({ type: 'GENERAL' });
      }

      this.$alertSuccess(response.message, 5000, true, "¡Duplicación exitosa!");
      this.manegeView(false);
    },

  },
};
</script>

<style scoped>
.content-process-duplicate-design {
  position: absolute;
  right: 0;
  width: 102%;
  height: calc(100% + 48pt);
  overflow: auto;
  background: #f4f4f4ba;
  top: -21px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
}

.content-process-duplicate-design-section-close {
  width: calc(100% - 479pt);
  height: calc(100% + 48pt);
}

.process-duplicate-design {
  height: 100vh;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: #f2f2f2;
  overflow-x: hidden;
  padding-top: 60px;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  overflow-y: auto;
  box-shadow: -4px 0 16px -3px #00000052;
}

.bg-header {
  background: #f4f4f4ba;
}

@media (min-width: 0pt) and (max-width: 700pt) {
  .process-duplicate-design {
    height: 100vh;
    width: 100%;
    left: 0;
  }
}
</style>
